import {
  FETCH_PRODUCT_PENDING,
  FETCH_PRODUCT_REJECTED,
  FETCH_PRODUCT_FULFILLED,
  ADD_BASKET_PENDING,
  ADD_BASKET_REJECTED,
  ADD_BASKET_FULFILLED
} from "../constants/productDetail";

import {
  FETCH_WIDGETS_FULFILLED,
  FETCH_WIDGETS_PENDING
} from "../constants/widgets";

const initialState = {
  pending: true,
  widgetPending: true,
  basketPending: false,
  product: {},
  widget: {},
  error: {},
  basketError: {},
  success: false
};

export const productDetail = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_PENDING:
      return {
        ...state,
        pending: true,
        success: false,
        product: {},
        error: {},
        basketError: {}
      };

    case FETCH_PRODUCT_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_PRODUCT_FULFILLED:
      return {
        ...state,
        product: action.response.product,
        variants: action.response.variants,
        selected_variant: action.response.selected_variant,
        pending: false,
        error: {}
      };

    case FETCH_WIDGETS_PENDING:
      return {
        ...state,
        widgetPending: true,
        error: {}
      }

    case FETCH_WIDGETS_FULFILLED:
      return {
        ...state,
        widget: action.response,
        widgetPending: false,
        error: {}
      }

    case ADD_BASKET_PENDING:
      return {
        ...state,
        basketPending: true,
        error: {},
        basketError: {},
        success: false
      };

    case ADD_BASKET_REJECTED:
      const error = action.error.response.data;
      return {
        ...state,
        basketPending: false,
        basketError: {
          basketError: error.non_field_errors && error.non_field_errors
        }
      };

    case ADD_BASKET_FULFILLED:
      return {
        ...state,
        basketPending: false,
        success: true
      }

    default:
      return state;

  }
};



// WEBPACK FOOTER //
// ./src/reducers/productDetail.js